import { Erro } from "../StatusIcones/erro";
import { Finalizado } from "../StatusIcones/finalizado";
import { Processando } from "../StatusIcones/processando";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { Indisponivel } from "../StatusIcones/indisponivel";
import { HttpResponse } from "_services/api/HttpResponse";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";
import { Play } from "../StatusIcones/play";
import { Lupa } from "../StatusIcones/lupa";

interface HandleStatusEmitirLicenciamentoProps {
  etapa: EtapaGerenciarEmplacamentosEnum;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  emitirLicenciamento: (id: number) => Promise<HttpResponse>;
  idProcesso: number;
  dados: IListarEmplacamentosPR[];
  setDados: (dados: IListarEmplacamentosPR[]) => void;
  setTooltipLeft: (left: number) => void;
  setTooltipTop: (top: number) => void;
  setTooltipConteudo: (conteudo: string | JSX.Element) => void;
  setTooltipWidth: (width: number) => void;
  setShowTooltip: (show: boolean) => void;
  abrirModalErroEmitirLicenciamento: (id: number, mensagemErro: string) => void;
  mensagemErro: string;
  codigoDeBarras: NullableString;
  listar: () => void;
}
export function HandleStatusEmitirLicenciamento({
  etapa,
  status,
  emitirLicenciamento,
  idProcesso,
  dados,
  setDados,
  setTooltipLeft,
  setTooltipTop,
  setTooltipConteudo,
  setTooltipWidth,
  setShowTooltip,
  abrirModalErroEmitirLicenciamento,
  mensagemErro,
  codigoDeBarras,
  listar,
}: HandleStatusEmitirLicenciamentoProps) {
  const handleStatus = (
    status: StatusEtapaGerenciarEmplacamentosEnum,
    mensagem?: string
  ) => {
    dados.forEach((processo) => {
      if (processo.id == idProcesso) {
        processo.statusEtapa = status;
        processo.etapa = EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO;

        if (mensagem) {
          processo.observacao = mensagem;
        }
      }
    });
    setDados(dados);
  };

  const onClick = async () => {
    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO);
    setDados([...dados]);
    const { hasErro, data } = await emitirLicenciamento(idProcesso);

    setShowTooltip(false);
    setTooltipLeft(0);
    setTooltipTop(0);
    setTooltipConteudo("");

    if (hasErro) {
      handleStatus(
        StatusEtapaGerenciarEmplacamentosEnum.ERRO,
        data?.message ?? null
      );
      return;
    }

    if (data?.recarregar) {
      await listar();
      return;
    }

    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO);
  };

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA,
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA,
  ];

  const etapasMuitoAnteriores = [
    EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_TAXA,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL,
  ];

  if (
    !codigoDeBarras ||
    !etapa ||
    (etapa == EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO &&
      status != StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO) ||
    etapasMuitoAnteriores.includes(etapa)
  ) {
    return <Indisponivel />;
  }

  if (
    (etapa && etapasPosteriores.includes(etapa)) ||
    (etapa == EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO &&
      status == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)
  ) {
    return <Finalizado />;
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.ERRO
  ) {
    return (
      <Erro
        onClick={() =>
          abrirModalErroEmitirLicenciamento(idProcesso, mensagemErro)
        }
      />
    );
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO
  ) {
    return (
      <Processando
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
      />
    );
  }

  return <Lupa acao={onClick} />;
}
